/* Dependencies */
import React, { Suspense, lazy } from 'react';

// Import lazy and Suspense
import { createRoot } from 'react-dom/client';

import 'babel-polyfill';
import _ from 'lodash';

import Loader from '@uicomponents/Loader';

import appI18n, { i18nInitPromise } from './i18n';
import './sass/index.sass';
import configureStore from './state/store/configureStore.js';

import '@webscopeio/react-textarea-autocomplete/style.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet/dist/leaflet.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'shepherd.js/dist/css/shepherd.css';

const LazyTransportialOTMS = lazy(() => import('./TransportialOTMS'));

/**
 *    The base instance of TransportialOTMS
 **/
export const store = configureStore();
export const i18n = appI18n;

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {})
    .catch((err) => {
      console.log('Service worker registration failed, error:', err);
    });
}

const root = createRoot(document.getElementById('transportial'));
i18nInitPromise
  .then(() => {
    root.render(
      <Suspense
        fallback={
          <div className="absolute-center center">
            <Loader />
          </div>
        }
      >
        <LazyTransportialOTMS />
      </Suspense>
    );
  })
  .catch((error) => {
    root.render(<div>Error loading application. Please try again later.</div>);
  });
